export default class JobDetails {
  assemblyName: string;
  className: string;
  methodName: string;
  arguments: { [key: string]: any };
}
